import React from 'react';
import Image from '../Image';
import { StyledLoaderImage } from './styled';
import loader from '../../assets/images/loader.png';

const LoaderImage = () => {
    return (
        <StyledLoaderImage>
            <Image
                src={loader}
                alt="Image"
                maxWidth="50px"
            />
        </StyledLoaderImage>
    );
};

export default React.memo(LoaderImage);